import React, { useState ,useEffect, useContext} from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { logoLight } from "../../assets/images";
import { UserConfigContext } from "../../context/UserConfigContext";
const SignUp = () => {
  const [formData, setFormData] = useState({
    email: "",
    nombre: "",
    direccion: "",
    localidad: "",
    codigoPostal: "",
    telefono: "",
    provincia: "",
    pais: "",
    inscripcion: "",
    tipoDoc: "",
    nroDoc: "",
    password: "",
    confirmPassword: ""
  });
  const [logo, setLogo] = useState("");
  const [empresaNombre, setEmpresaNombre] = useState("");
  const { config1, config2 } = useContext(UserConfigContext);
  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");


  useEffect(() => {
    if (config1 && config1.empresa) {
      setLogo(config1.empresa.logo);
      setEmpresaNombre(config1.empresa.nombre);
    }
  }, [config1]); // Se agregó config2 en las dependencias

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const validateEmail = (email) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!validateEmail(formData.email)) newErrors.email = "Email inválido.";
    if (!formData.nombre) newErrors.nombre = "Campo requerido.";
    if (!formData.password) newErrors.password = "Campo requerido.";
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Las contraseñas no coinciden.";
    if (!formData.telefono.match(/^\d+$/)) newErrors.telefono = "Teléfono inválido.";
    if (!formData.nroDoc.match(/^\d+$/)) newErrors.nroDoc = "Documento inválido.";

    // Agregar validación para campos obligatorios
    const requiredFields = ["direccion", "localidad", "codigoPostal", "provincia", "pais", "inscripcion", "tipoDoc"];
    requiredFields.forEach(field => {
      if (!formData[field]) newErrors[field] = "Campo requerido.";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setSuccessMsg("¡Cuenta creada con éxito!");
      // Enviar formData al backend...
    }
  };
  return (
    <div className="w-full h-screen flex items-center justify-start">
    <div className="w-1/2 hidden lgl:inline-flex h-full text-white">
        <div className="w-[450px] h-full bg-primeColor px-10 flex flex-col gap-6 justify-center">
      
        <div className="flex flex-col items-center gap-2">
    <Link to="/">
      <img src={logo} alt="logoImg" className="w-50" />
    </Link>
    <span className="text-white text-lg font-semibold">{empresaNombre}</span>
  </div>
         {/* <div className="flex flex-col gap-1 -mt-1">
            <h1 className="font-titleFont text-xl font-medium">
              Get started for free
            </h1>
            <p className="text-base">Create your account to access more</p>
          </div>
          <div className="w-[300px] flex items-start gap-3">
            <span className="text-green-500 mt-1">
              <BsCheckCircleFill />
            </span>
            <p className="text-base text-gray-300">
              <span className="text-white font-semibold font-titleFont">
                Get started fast with OREBI
              </span>
              <br />
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab omnis
              nisi dolor recusandae consectetur!
            </p>
          </div>
          <div className="w-[300px] flex items-start gap-3">
            <span className="text-green-500 mt-1">
              <BsCheckCircleFill />
            </span>
            <p className="text-base text-gray-300">
              <span className="text-white font-semibold font-titleFont">
                Access all OREBI services
              </span>
              <br />
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab omnis
              nisi dolor recusandae consectetur!
            </p>
          </div>
          <div className="w-[300px] flex items-start gap-3">
            <span className="text-green-500 mt-1">
              <BsCheckCircleFill />
            </span>
            <p className="text-base text-gray-300">
              <span className="text-white font-semibold font-titleFont">
                Trusted by online Shoppers
              </span>
              <br />
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab omnis
              nisi dolor recusandae consectetur!
            </p>
          </div>
          <div className="flex items-center justify-between mt-10">
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              © OREBI
            </p>
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              Terms
            </p>
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              Privacy
            </p>
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              Security
            </p>
          </div>*/}
        </div>
      </div>
      <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
        {successMsg ? (
          <div className="w-[500px]">
            <p className="w-full px-4 py-10 text-green-500 font-medium font-titleFont">
              {successMsg}
            </p>
            <Link to="/signin">
              <button className="w-full h-10 bg-primeColor rounded-md text-gray-200 text-base font-titleFont font-semibold tracking-wide hover:bg-black hover:text-white duration-300">
                Iniciar sesión
              </button>
            </Link>
          </div>
        ) : (
          <form className="w-full h-screen flex items-center justify-center" onSubmit={handleSignUp}>
  <div className="w-full max-w-screen-lg h-auto">
    
    <h1 className="font-titleFont underline underline-offset-4 decoration-[1px] font-semibold text-2xl mdl:text-3xl mb-4">
      Crea tu Cuenta
    </h1>

    <div className="flex flex-col gap-3 mb-6">
      <label>Email</label>
      <input type="email" name="email" value={formData.email} onChange={handleChange} className="p-1.5 border rounded w-full text-sm" />
      {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
    </div>

    {/* Contraseñas en dos columnas */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div>
        <label>Contraseña</label>
        <input type="password" name="password" value={formData.password} onChange={handleChange} className="p-1.5 border rounded w-full text-sm" />
        {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
      </div>

      <div>
        <label>Confirmar Contraseña</label>
        <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="p-1.5 border rounded w-full text-sm" />
        {errors.confirmPassword && <p className="text-red-500 text-sm">{errors.confirmPassword}</p>}
      </div>
    </div>

    {/* Otros campos */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {[
        { label: "Nombre", name: "nombre" },
        { label: "Dirección", name: "direccion" },
        { label: "Localidad", name: "localidad" },
        { label: "Código Postal", name: "codigoPostal" },
        { label: "Teléfono", name: "telefono" },
        { label: "Número de Documento", name: "nroDoc" }
      ].map(({ label, name }) => (
        <div key={name}>
          <label>{label}</label>
          <input type="text" name={name} value={formData[name]} onChange={handleChange} className="p-1.5 border rounded w-full text-sm" />
          {errors[name] && <p className="text-red-500 text-sm">{errors[name]}</p>}
        </div>
      ))}

      <div>
        <label>Provincia</label>
        <select name="provincia" value={formData.provincia} onChange={handleChange} className="p-1.5 border rounded w-full text-sm">
          <option value="">Seleccionar...</option>
          <option>Buenos Aires</option>
          <option>Córdoba</option>
          <option>Santa Fe</option>
        </select>
        {errors.provincia && <p className="text-red-500 text-sm">{errors.provincia}</p>}
      </div>

      <div>
        <label>País</label>
        <select name="pais" value={formData.pais} onChange={handleChange} className="p-1.5 border rounded w-full text-sm">
          <option value="">Seleccionar...</option>
          <option>Argentina</option>
          <option>Uruguay</option>
          <option>Chile</option>
        </select>
        {errors.pais && <p className="text-red-500 text-sm">{errors.pais}</p>}
      </div>

      <div>
        <label>Inscripción Afín</label>
        <select name="inscripcion" value={formData.inscripcion} onChange={handleChange} className="p-1.5 border rounded w-full text-sm">
          <option value="">Seleccionar...</option>
          <option>Consumidor Final</option>
          <option>Responsable Inscripto</option>
        </select>
        {errors.inscripcion && <p className="text-red-500 text-sm">{errors.inscripcion}</p>}
      </div>

      <div>
        <label>Tipo de Documento</label>
        <select name="tipoDoc" value={formData.tipoDoc} onChange={handleChange} className="p-1.5 border rounded w-full text-sm">
          <option value="">Seleccionar...</option>
          <option>DNI</option>
          <option>CUIT</option>
          <option>Pasaporte</option>
        </select>
        {errors.tipoDoc && <p className="text-red-500 text-sm">{errors.tipoDoc}</p>}
      </div>
    </div>

    <button type="submit" className="mt-6 w-full bg-primeColor text-white p-2 rounded hover:bg-black duration-300">
      Crear Cuenta
    </button>

    <p className="text-sm text-center mt-4 font-titleFont font-medium">
      ¿Ya tenés cuenta?{" "}
      <Link to="/signin">
        <span className="hover:text-blue-600 duration-300">Iniciar sesión</span>
      </Link>
    </p>
  </div>
</form>

        )}
      </div>
    </div>
  );
};

export default SignUp;
